module.exports = __webpack_public_path__ + "img/popular-categories-7.c7c8dc1c.png";